




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";
import _ from "lodash";

interface Request {
    allocations: Allocation[];
}

interface Allocation {
    amount: number;
}

@Component({ components: { SimpleText } })
export default class Budget extends Vue {
    @Prop( { default: null }) public request !: Request;

    public static getNeededFields(): string[] {
        return [
            "request.allocations.amount",
            "request.children.allocations.amount",
        ];
    }

    public get budget(): number {
        const allocations = _.get(this.request, "allocations", null);

        return _.sumBy(allocations, (allocation) => {
            return allocation.amount;
        });
    }
}
